import { useState } from "react";
import axios from "axios";
import { motion } from "framer-motion";
import { toast } from "sonner";
import { FaMapMarkerAlt, FaPhoneAlt, FaEnvelope, FaClock, FaPaperPlane, FaWhatsapp } from "react-icons/fa";
import { Input } from "./ui/input";
import { Textarea } from "./ui/textarea";
import { COMPANY } from "../data/content";

const API = "http://localhost:8001/api"; // Direct link for testing

const Contact = () => {
    const [form, setForm] = useState({ 
        name: "", 
        email: "", 
        phone: "", 
        organization: "", 
        subject: "", 
        message: "" 
    });
    const [loading, setLoading] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        
        // Simple check before sending
        if (!form.name || !form.email || !form.phone || !form.message) {
            toast.error("Please fill in Name, Email, Phone, and Message.");
            return;
        }

        setLoading(true);
        try {
            await axios.post(`${API}/contact`, form);
            toast.success("Thank you! We'll get in touch shortly.");
            setForm({ name: "", email: "", phone: "", organization: "", subject: "", message: "" });
        } catch (err) {
            console.error(err);
            toast.error("Submission failed. Check if Backend is running.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <section id="contact" className="relative py-20 sm:py-28">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="grid lg:grid-cols-5 gap-8">
                    {/* Left Side: Info */}
                    <div className="lg:col-span-2 space-y-4">
                        <div className="p-6 rounded-3xl bg-blue-700 text-white shadow-xl">
                            <h3 className="font-bold text-xl mb-4">Contact Details</h3>
                            <p className="text-sm opacity-90 mb-6">{COMPANY.address}</p>
                            <p className="text-sm font-bold">{COMPANY.phone}</p>
                        </div>
                    </div>

                    {/* Right Side: Form */}
                    <form onSubmit={submit} className="lg:col-span-3 p-8 rounded-3xl bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-800 shadow-sm space-y-4">
                        <Input placeholder="Name *" value={form.name} onChange={e => setForm({...form, name: e.target.value})} />
                        <Input placeholder="Email *" type="email" value={form.email} onChange={e => setForm({...form, email: e.target.value})} />
                        <Input placeholder="Phone *" value={form.phone} onChange={e => setForm({...form, phone: e.target.value})} />
                        <Textarea placeholder="Message *" rows={4} value={form.message} onChange={e => setForm({...form, message: e.target.value})} />
                        <button 
                            disabled={loading}
                            className="w-full py-4 rounded-full bg-blue-700 text-white font-bold hover:bg-blue-600 transition"
                        >
                            {loading ? "Sending..." : "Send Message"}
                        </button>
                    </form>
                </div>
            </div>
        </section>
    );
};

export default Contact;
